var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',[_c('mdb-autocomplete',{attrs:{"data":_vm.searchResults,"label":_vm.searchLabel},on:{"clear":_vm.clearSearch,"search":_vm.handleSearch},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }